/*
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: 小白
 * @Date: 2025-08-04 17:31:55
 * @LastEditors: 小白
 * @LastEditTime: 2025-09-04 09:24:19
 * @FilePath: \tmswebsite\src\utils\http.js
 */
import axios from 'axios'
export  const baseURL = 'https://api.kpsd56.com'
export default axios.create({
  baseURL: 'https://kd.kpsd56.com',
  withCredentials: true,
  timeout: 5000,
});